import { Box, Typography, styled } from "@mui/material"

export const HistoricalWrapper = styled(Box)({
  width: "320px",
  maxHeight: "400px",
  // height: "auto",
})

export const HistoricalHeaderTypo = styled(Typography)({
  padding: "0px 30px",
  paddingBottom: "15px",
})

export const HistoricalHeadBox = styled(Box)({
  width: "300px",
  minHeight: "40px",
  height: "auto",
  backgroundColor: "#3366D6",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "0px 30px",
})

export const HistoricalHeadBoxOne = styled(Box)({
  width: "110px",
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  //padding: "0px  30px",
})

export const HistoricalHeadBoxOneTypo = styled(Typography)({
  color: "#fff",
  fontSize: "13px",
})
export const HistoricalHeadBoxTwo = styled(Box)({
  width: "110px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
})
export const HistoricalHeadBoxTwoTypo = styled(Typography)({
  color: "#fff",
  fontSize: "13px",
  textTransform: "capitalize",
})

export const HistoricalDataWrapper = styled(Box)({
  width: "300px",
  height: "60px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "0px 30px 0px 30px",
  borderBottom: "1px solid #E4E4E4",
})
export const HistoricalDataMonth = styled(Box)({
  color: "#000",
  fontSize: "14px",
  textTransform: "capitalize",
})
export const HistoricalDataValue = styled(Box)({
  color: "#000",
  fontSize: "14px",
  textTransform: "capitalize",
  width: "110px",
  height: "45px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
})
export const HistoricalLoadingWrapper = styled(Box)({
  width: "300px",
  height: "300px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
})
